import { Component } from '@angular/core';

@Component({
	selector: 'ifective-notfound',
	templateUrl: './notfound.component.html',
	styleUrls: ['./notfound.component.scss']
})
export class NotfoundComponent {

	constructor() {

	}
}
